import { apiRequestPost } from 'mastodon/api';

export interface ApiNgWordWarningJSON {
  account: { id: string; acct: string; display_name: string };
  words: string[];
}

export const apiCheckNgWords = (params: {
  status: string;
  spoiler_text?: string;
}) =>
  apiRequestPost<{ warnings: ApiNgWordWarningJSON[] }>(
    'v1/ng_words/check',
    params,
  );
